<template>
  <div class="component text" :data-orientation="orientation" data-viewport>
    <!-- Single column text -->
    <div class="text__content" v-if="!Array.isArray(data.content)">
        <h4 v-html="data.content.title" v-if="data.content.title" data-medusa-animation="slide-fade"></h4>
        <h5 v-html="data.content.subtitle" v-if="data.content.subtitle" data-medusa-animation="slide-fade"></h5>
        <p v-html="data.content.text" data-medusa-animation="slide-fade"></p>
    </div>
    <!-- Double column text -->
    <div class="text__columns" v-else>
      <div v-for="(column, key) in data.content" :key="key" class="text__column">
        <h4 v-html="column.title" data-medusa-animation="slide-fade"></h4>
        <p v-html="column.text" data-medusa-animation="slide-fade"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextBlock',

  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    orientation: {
      type: String,
      required: false,
      default: () => 'right',
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  padding: $vertical-padding $extra-horizontal-padding;

  @include mq($until: ipadL) {
    padding: $mobile-vertical-padding $extra-mobile-horizontal-padding;
  }

  &__content,
  &__columns {
    width: calc((100vw / 32) * 14);
    margin-left: auto;

    @include mq($until: ipadL) {
      width: 100%;
    }

    p {
      font-size: rem(27px);
      font-size: calc(27px * var(--rw));
      line-height: rem(40px);
      line-height: calc(40px * var(--rw));
    }
  }

  &[data-orientation="left"] {
    .text__content {
      margin-left: 0;
      margin-right: auto;
    }
  }

  &__content {
    h4 {
      font-size: rem(70px);
      font-size: calc(70px * var(--rw));
      line-height: rem(120px);
      line-height: calc(120px * var(--rw));
    }

    h5 {
      font-size: rem(36px);
      font-size: calc(36px * var(--rw));
      line-height: rem(48px);
      line-height: calc(48px * var(--rw));

      margin-bottom: calc((100vh / 18) * 1);
    }
  }

  &__columns {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @include mq($until: ipadL) {
      flex-direction: column;
    }

    .text__column {
      max-width: 45%;
      min-width: 45%;

      @include mq($until: ipadL) {
        max-width: 100%;
        min-width: 100%;

        &:last-child {
          margin-top: 40px;
        }
      }
    }

    h4 {
      font-size: rem(27px);
      font-size: calc(27px * var(--rw));
      line-height: rem(48px);
      line-height: calc(48px * var(--rw));
    }
  }
}
</style>
